// Kill-switch for every surface that invites the user to pose a free-form
// question to the AI: the topbar "Ask about this…" launcher, the analysis
// modal's follow-up composer and question chips, and the copilot chat inputs
// in the forecast/growth workspaces. The open-ended answer path isn't good
// enough yet, so these affordances are hidden until the backend is ready.
// Guided, recipe-backed analysis (drilldowns, Explain cards, deterministic
// "Do this next" actions) is unaffected.
//
// Re-enable globally by flipping the default below. For internal testing in a
// single browser: localStorage.setItem('fusegrid_open_ended_ask', '1')
export const OPEN_ENDED_ASK_DEFAULT_ENABLED = false

const LS_OPEN_ENDED_ASK_KEY = 'fusegrid_open_ended_ask'

export const isOpenEndedAskEnabled = (): boolean => {
  if (typeof window === 'undefined') return OPEN_ENDED_ASK_DEFAULT_ENABLED
  try {
    const v = String(window.localStorage.getItem(LS_OPEN_ENDED_ASK_KEY) || '').trim().toLowerCase()
    if (v === '1' || v === 'true' || v === 'on') return true
    if (v === '0' || v === 'false' || v === 'off') return false
  } catch {
    // localStorage unavailable (private mode / SSR shims) — fall through
  }
  return OPEN_ENDED_ASK_DEFAULT_ENABLED
}
